import { FontAwesome } from './fontAwesome';

export default () => {
  FontAwesome();
};
